import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `a.p-menubar-item-link-active {
  color: ${dt('menubar.item.activeColor')};
  font-weight: ${dt('appMenubar.item.activeFontWeight')};
}

.p-menubar-root-list > .p-menubar-item > .p-menubar-item-content .p-menubar-submenu-icon {
  transition: transform 0.2s;
}

.p-menubar-root-list > .p-menubar-item-active > .p-menubar-item-content .p-menubar-submenu-icon {
  transform: rotate(180deg);
}

.p-menubar-root-list > .p-menubar-item:has(> .p-menubar-submenu a.p-menubar-item-link-active) > .p-menubar-item-content .p-menubar-item-link {
  color: ${dt('menubar.item.activeColor')};
  font-weight: ${dt('appMenubar.item.activeFontWeight')};
}

p-menubar.p-menubar-mobile-active {
  & ul.p-menubar-root-list {
    width: 192px;
  }

  & .p-menubar-submenu {
    min-width: 0;
  }

  & a:hover {
    color: ${dt('menubar.item.focusColor')};
  }

  & a.p-menubar-button {
    color: ${dt('appMenubar.mobileButton.activeColor')};
  }

  & a.p-menubar-button:hover {
    color: ${dt('menubar.mobileButton.hoverColor')};
  }
}`;
